var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import { useGetFile } from "../../queries/bucket";
import { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
export default function Home() {
    var params = useParams();
    var data = useGetFile(params.filePath).data;
    useEffect(function () {
        if (data) {
            window.location.href = data.url;
        }
    }, [data]);
    return (_jsx(Box, __assign({ sx: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 8,
        } }, { children: _jsx(CircularProgress, {}) })));
}
